import { ComponentPropsWithRef, forwardRef } from 'react';

import { ButtonStyled } from './SingleButtonSelect.styles';

export interface SingleButtonProps extends ComponentPropsWithRef<'button'> {
  isSelected?: boolean;
  doNotWrapText?: boolean;
}

export const SingleButton = forwardRef<HTMLButtonElement, SingleButtonProps>(function SingleButton(
  { children, isSelected, doNotWrapText, ...props },
  ref,
) {
  return (
    <ButtonStyled ref={ref} aria-selected={isSelected} data-do-not-wrap-text={!!doNotWrapText} {...props}>
      {children}
    </ButtonStyled>
  );
});
